import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography } from '@material-ui/core';

import GenericIcon from '../../../../../../../common/icons/fontIcons/genericIcon';

import creditBlackCard from '../../../../../../../../assets/bank/blackCard.svg';
import ripleyPurpleCard from '../../../../../../../../assets/bank/purpleCard.svg';
import checkIcon from '../../../../../../../../assets/bank/checkLogo.svg';
import oneStar from '../../../../../../../../assets/r_puntos_go_logo.svg';

import noSubscribedStyle from '../styles';

const otherPointsTexts = [
  <span key={1}>
    Por cada <b>$1.000</b> por <b>contratación de Avances</b>,{' '}
    <b>Súper Avances</b> y <b>Créditos de Consumo</b>
  </span>,
  <span key={2}>
    Cada <b>$125</b> por contratación de <b>Seguros Ripley</b> con la{' '}
    <b>Tarjeta Ripley Mastercard</b>
  </span>,
  <span key={3}>
    Cada <b>$500</b> con otros <b>medios de pago</b> en <b>Tiendas Ripley</b>
  </span>,
];

const CardImage = ({ size, src }) => (
  <span>
    <img height={size} width={size} src={src} />
  </span>
);

CardImage.propTypes = {
  size: PropTypes.number,
  src: PropTypes.node,
};

const OneStart = () => {
  const classes = noSubscribedStyle();

  return (
    <span>
      <span className={classes.purpleLink}>1 </span>
      <img className={classes.rpgoImage} src={oneStar} />
    </span>
  );
};

const StarInformationByCard = ({ values, mobile }) => {
  const classes = noSubscribedStyle({ mobile });
  const mobileText = [
    'Ripley / Ripley.com / Seguros Ripley',
    'Otros comercios',
  ];

  return (
    <React.Fragment>
      {values.map((element, key) => (
        <div className={classes.starContainer} key={key}>
          <OneStart />
          <br />
          <span>
            Por cada ${element} {mobile && `en ${mobileText[key]}`}
          </span>
        </div>
      ))}
    </React.Fragment>
  );
};

StarInformationByCard.propTypes = {
  mobile: PropTypes.bool,
  values: PropTypes.array,
};

const HowAccumulate = (props) => {
  const { mobile } = props;
  const classes = noSubscribedStyle({ mobile });

  return (
    <React.Fragment>
      <Typography className={classes.tabPanelTitle}>
        ¿Cómo acumulas puntos?
      </Typography>
      <Grid container spacing={6} className={classes.accumulateOptions}>
        <Grid item xs={12} md={6}>
          <Typography className={classes.iconTextDescription}>
            <GenericIcon color="gray" size={39} fontClass="icon-ic_tienda" />
            Dictando tu RUT cada vez que realices una compra en Tiendas Ripley o
            en Ripley.com
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography className={classes.iconTextDescription}>
            <GenericIcon color="gray" size={39} fontClass="icon-ic_trc" />
            Usando tus Tarjetas de crédito y débito Ripley en tus compras.
          </Typography>
        </Grid>
      </Grid>
      <Typography className={classes.tabPanelTitle}>
        Detalle de acumulación
        <br />
        <span className={classes.dateValid}>
          Válido a partir del 06/02/2021
        </span>
      </Typography>
      {!mobile && (
        <div className={classes.divThreeGridTitle}>
          <span> </span>
          <span>Ripley / Ripley.com / Seguros Ripley</span>
          <span>Otros comercios</span>
        </div>
      )}
      <div className={classes.divThreeGrid}>
        <CardImage size={100} src={creditBlackCard} />
        <StarInformationByCard mobile={mobile} values={[125, 125]} />
      </div>
      <div className={classes.divThreeGrid}>
        <CardImage size={100} src={ripleyPurpleCard} />
        <StarInformationByCard mobile={mobile} values={[250, 500]} />
      </div>
      <div className={classes.divThreeGrid}>
        <CardImage size={70} src={checkIcon} />
        <StarInformationByCard mobile={mobile} values={[333, 1000]} />
      </div>
      <div className={classes.divStar}>
        {otherPointsTexts.map((text, key) => (
          <div key={key} className={classes.gridOneStar}>
            <OneStart />
            <div>{text}</div>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
};

HowAccumulate.propTypes = {
  mobile: PropTypes.bool,
};

export default HowAccumulate;
